var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#3293E6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 21.333a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 22.4V12.267c0-1.494 0-2.24.29-2.811.256-.502.664-.91 1.166-1.165C6.026 8 6.773 8 8.266 8h1.407c.164 0 .246 0 .321-.009.395-.045.749-.264.966-.596.041-.064.078-.137.151-.284.147-.293.22-.44.303-.567a2.67 2.67 0 0 1 1.93-1.193c.152-.018.316-.018.644-.018h4.024c.328 0 .492 0 .643.018.79.09 1.497.527 1.93 1.193.084.127.157.274.304.567.073.147.11.22.151.284.217.332.571.551.966.596.075.009.157.009.321.009h1.406c1.494 0 2.24 0 2.811.29.502.256.91.664 1.165 1.166.291.57.291 1.317.291 2.81V22.4c0 1.494 0 2.24-.29 2.81-.256.502-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29H8.266c-1.494 0-2.24 0-2.811-.29a2.67 2.67 0 0 1-1.165-1.165C4 24.64 4 23.894 4 22.4"
}))));
export { SvgCamera as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvY2FtZXJhLjBkOGViY2FmLnN2ZyI7";